module.exports = __webpack_public_path__ + "static/media/holidaypackages.2c7be573.png";